function hideInstructionsOnPage(shopSystem) {
  let instructions = document.querySelectorAll(`[shop-setup-instructions="${shopSystem}"]`);

  instructions.forEach((instruction) => {
    instruction.children[0].classList.add('d-none');
  })
}

function showInstructionsOnPage(shopSystem) {
  let instructions = document.querySelectorAll(`[shop-setup-instructions="${shopSystem}"]`);

  instructions.forEach((instruction) => {
    instruction.children[0].classList.remove('d-none');
  })
}

// event handler for closing instructions
compiler('[hide-shop-setup-instructions]', (element) => {
  const shopSystem = element.getAttribute('hide-shop-setup-instructions');
  const csrf_token = document.head.querySelector('meta[name="csrf-token"][content]').content;

  element.addEventListener("click", (event) => {
    fetch(`/shop_setup_instructions/${shopSystem}/hide`, {method: 'POST', headers: {'X-CSRF-Token': csrf_token}})
      .then(response => response.json())
      .then((response) => {
        if(response.success === true) {
          hideInstructionsOnPage(shopSystem);

          let hide_instruction_checkbox = document.querySelectorAll(`input[name="hide_shop_setup_instructions"][data-shop-system="${shopSystem}"]`);
          hide_instruction_checkbox.forEach((checkbox) => {
            checkbox.checked = true;
          })
        }
      }).catch(error => {
        console.error(`Couldn't hide setup up instruction for ${shopSystem}`, error)
    });
  });
});

// hide/show instructions when setting is changed by remote form
compiler('input[name="hide_shop_setup_instructions"]', (element) => {
  const shopSystem = element.getAttribute('data-shop-system');

  element.form.addEventListener("submit", function() {
    if(element.checked) {
      hideInstructionsOnPage(shopSystem);
    } else {
      showInstructionsOnPage(shopSystem);
    }
  });
});
